import { ContentContainer } from '../../components/ContentContainer';
import { ImgWithSkeleton } from '../../components/ui/ImgWithSkeleton';
import type { WineryGalleryProps } from './types';

export const WineryGallery = ({ imageIds, galleryImages, onImageClick }: WineryGalleryProps) => {
  return (
    <ContentContainer>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Gallery</h2>
      {imageIds.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.slice(0, 6).map((media, index) => (
            <div
              key={media.id}
              className="aspect-square overflow-hidden rounded-lg cursor-pointer"
              onClick={() => onImageClick(index)}
            >
              <ImgWithSkeleton
                src={media.cloudinaryUrl}
                alt={media.caption || 'Venue image'}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
                skeletonClassName="rounded-lg"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No gallery images available</p>
      )}
    </ContentContainer>
  );
};
